import { ReactComponent as SvgLine27 } from '../pictograms/line-27.svg';
import { ReactComponent as SvgLine47 } from '../pictograms/line-47.svg';
import { ReactComponent as SvgLine57 } from '../pictograms/line-57.svg';
import { ReactComponent as SvgLine59 } from '../pictograms/line-59.svg';
import { ReactComponent as SvgLine61 } from '../pictograms/line-61.svg';
import { ReactComponent as SvgLine64 } from '../pictograms/line-64.svg';
import { ReactComponent as SvgLine67 } from '../pictograms/line-67.svg';
import { ReactComponent as SvgLine83 } from '../pictograms/line-83.svg';

export function BusLinesPlaceItalie() {
  return (
    <span
      className="bus-lines"
      role="group"
      aria-label="Lignes de bus RATP à Place d'Italie"
    >
      <SvgLine27 className="bus-lines__line" aria-label="Ligne 27" role="img" />
      <SvgLine47 className="bus-lines__line" aria-label="Ligne 47" role="img" />
      <SvgLine57 className="bus-lines__line" aria-label="Ligne 57" role="img" />
      <SvgLine59 className="bus-lines__line" aria-label="Ligne 59" role="img" />
      <SvgLine61 className="bus-lines__line" aria-label="Ligne 61" role="img" />
      <SvgLine64 className="bus-lines__line" aria-label="Ligne 64" role="img" />
      <SvgLine67 className="bus-lines__line" aria-label="Ligne 67" role="img" />
      <SvgLine83 className="bus-lines__line" aria-label="Ligne 83" role="img" />
    </span>
  );
}
